module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/background_mobile-570ce760ec2869b05f75f457f0496870.webp";